import { resourceListBindings } from 'tmr/components/resourceList/resourceListHelper'
import templateUrl from './conveyorPackageEvents.html'

/**
 * Conveyor Package Event route
 *
 * @namespace routes.ReportConveyorPackageEvents
 * @type {TmrRoute}
 */
export const route = {
  name: 'report.conveyorPackageEvents.list',
  label: 'REPORT.CONVEYORPACKAGEEVENTS.MENUTITLE',
  url: '/conveyorPackageEvents',
  component: 'tmrReportConveyorPackageEvents',
  weight: 24,
  resourceType: 'ConveyorPackageEvent',
  resourceList: {
    searchParameters: [
      'conveyor.id',
      'packageCode',
      'conveyor.place.id',
      'barcodeTimestamp.from',
      'barcodeTimestamp.to',
      'photocellStartTimestamp.from',
      'photocellStartTimestamp.to',
      'photocellEndTimestamp.from',
      'photocellEndTimestamp.to',
      'creationDate.from',
      'creationDate.to',
    ],
  },
  accessControl: ['Resource.list', 'Resource.ConveyorPackageEvent.list'],
}

/**
 * Component for {@link routes.tmrReportConveyorPackageEvents Conveyor Package Event route}
 *
 * @type {ngComponent}
 */
export const tmrReportConveyorPackageEvents = {
  ngType: 'component',
  templateUrl,
  bindings: resourceListBindings(),
}
